import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: {
      translations: require('./locales/en/translations.json')
    },
    // ru: {
    //   translations: require('./locales/ru/translations.json')
    // },
    es: {
      translations: require('./locales/es/translation.json')
    },
    it: {
      translations: require('./locales/it/translation.json')
    },
    cz: {
      translations: require('./locales/cz/translation.json')
    },
    de: {
      translations: require('./locales/de/translation.json')
    }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en', 'de' , 'es','cz','it'];

export default i18n;